export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "articles_in_section": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles in this section"])}
    }
  })
}
